import Api from "../axios";

export const postCreateReward = async (data) => {
  return await Api.post("/Game/Create-Reward", data);
};
